// Quando algo aconteceu, no horário de Brasília: "agora", "há 5 min", "há 2 h", "ontem", "seg" (nesta semana) ou
// "12/10". Para as notificações; o "visto há" dos amigos usa a mesma conta.
const DIA = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit' });
const SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
const diaDe = (ms: number) => DIA.format(new Date(ms));
const diasEntre = (a: number, b: number) => Math.round((Date.parse(diaDe(b)) - Date.parse(diaDe(a))) / 86_400_000);

export function quandoFoi(agora: number, em: number): string {
  const min = Math.floor((agora - em) / 60_000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  const dias = diasEntre(em, agora);
  if (dias === 0) return `há ${Math.floor(min / 60)} h`;
  if (dias === 1) return 'ontem';
  const d = new Date(em - 3 * 3_600_000); // em Brasília
  if (dias < 7) return SEMANA[d.getUTCDay()]!;
  return `${String(d.getUTCDate()).padStart(2, '0')}/${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

// Grupo da lista de notificações: hoje, esta semana (últimos 7 dias) ou antes.
export function grupoDe(agora: number, em: number): 'hoje' | 'semana' | 'antes' {
  const dias = diasEntre(em, agora);
  return dias === 0 ? 'hoje' : dias < 7 ? 'semana' : 'antes';
}

// "Visto há" dos amigos: "visto agora", "visto há 5 min", "visto há 2 h", "visto ontem", "visto há 3 dias",
// "visto há 2 semanas" ou "visto há mais de um mês". Sem registro: "sem visita recente".
export function textoVisto(agora: number, em: number | null): string {
  if (em === null) return 'sem visita recente';
  const min = Math.floor((agora - em) / 60_000);
  if (min < 1) return 'visto agora';
  if (min < 60) return `visto há ${min} min`;
  const dias = diasEntre(em, agora);
  if (dias === 0) return `visto há ${Math.floor(min / 60)} h`;
  if (dias === 1) return 'visto ontem';
  if (dias < 14) return `visto há ${dias} dias`;
  if (dias < 31) return `visto há ${Math.floor(dias / 7)} semanas`;
  return 'visto há mais de um mês';
}
